import PageHero from "@/components/PageHero";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Seo from "@/components/Seo";
import { pageImages, links } from "@/data";

const brands = [
  { emoji: "\uD83D\uDC06", name: "Hi DMC", cover: pageImages.brandCoverDMC, href: links.hiDMC, desc: "A full-service destination management company with on-ground teams and infrastructure across 15+ destinations, trusted by global travel brands for seamless execution and local expertise." },
  { emoji: "\uD83E\uDD41", name: "Hi Offsite", cover: pageImages.brandCoverOffsite, href: links.hiOffsite, desc: "We craft unforgettable offsites, retreats, and incentive trips for companies looking to reward, recharge, and realign their teams across India and beyond." },
  { emoji: "\uD83C\uDFDD\uFE0F", name: "Hi Tours", cover: pageImages.brandCoverTours, href: links.hiTours, desc: "From once-in-a-lifetime escapes to handpicked group adventures, Hi Tours curates travel for modern explorers seeking comfort, culture, and connection." },
];

const BrandsPage = () => (
  <main className="page">
    <Seo
      title="Our Brands"
      path="/brands"
      description="Three brands, one purpose. Hi DMC for destination management, Hi Tours for curated holidays, and Hi Offsite for corporate offsites and MICE travel."
    />
    <PageHero eyebrow="Our Brands" title="Three Brands. One Purpose. Exceptional Travel!" subtitle="From global DMC services to curated holidays and corporate offsites, Hi Tours Group unites distinct brands built to serve every kind of traveler." />

    <section className="section">
      <div className="container brand-rows">
        {brands.map((b, i) => (
          <a className={`brand-row ${i % 2 ? "brand-row--rev" : ""}`} key={b.name} href={b.href} target="_blank" rel="noopener noreferrer">
            <div className="brand-row__media">
              <img src={b.cover} alt={b.name} loading="lazy" />
            </div>
            <div className="brand-row__body">
              <span className="brand-row__emoji">{b.emoji}</span>
              <h3 className="brand-row__name">{b.name}</h3>
              <p className="brand-row__desc">{b.desc}</p>
              <span className="brand-row__link">Visit {b.name}
                <span className="icon-plus">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" /></svg>
                </span>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>

    <Testimonials />
    <CTA />
  </main>
);

export default BrandsPage;
